// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"38164e15","65":"9607ce35","263":"3b635a27","488":"618203a1","622":"765821de","737":"a21c18ae"}[chunkId] + ".chunk.js";
};